import Vue from 'vue';

export const directiveFocusOne = Vue.directive('focus', {
  inserted(el) {
    el.focus();
  },
});

export const directiveFocusTwo = Vue.directive('focus2', {
  inserted(el) {
    el.focus();
  },
});

// export const directiveDemo = Vue.directive('demo', {
//   bind(el, binding, vnode, oldVnode) {

//     const s = JSON.stringify;

//     // console.log('========bind========');
//     // console.log('el', el);
//     // console.log('binding', binding);

//     // console.log('name: ', s(binding.name));
//     // console.log('value: ', s(binding.value));
//     // console.log('expression: ', s(binding.expression));
//     // console.log('argument: ', s(binding.arg));
//     // console.log('modifiers: ', s(binding.modifiers));
//     // console.log('vnode keys: ', Object.keys(vnode).join(', '));

//     // console.log('vnode', vnode);
//     // console.log('oldVnode', oldVnode);
//     // console.log('================');
//   },
//   inserted(el, binding, vnode, oldVnode) {

//     // console.log('=======inserted=========');
//     // console.log('el', el);
//     // console.log('binding', binding);
//     // console.log('vnode', vnode);
//     // console.log('oldVnode', oldVnode);
//     // console.log('================');

//   },
//   update(el, binding, vnode, oldVnode) {

//     // console.log('========update========');
//     // console.log('el', el);
//     // console.log('binding', binding);
//     // console.log('vnode', vnode);
//     // console.log('oldVnode', oldVnode);
//     // console.log('================');

//   },
//   componentUpdated(el, binding, vnode, oldVnode) {
    
//     // console.log('========componentUpdated========');
//     // console.log('el', el);
//     // console.log('binding', binding);
//     // console.log('vnode', vnode);
//     // console.log('oldVnode', oldVnode);
//     // console.log('================');

//   },
//   unbind(el, binding, vnode, oldVnode) {

//     // console.log('========unbind========');
//     // console.log('el', el);
//     // console.log('binding', binding);
//     // console.log('vnode', vnode);
//     // console.log('oldVnode', oldVnode);
//     // console.log('================');

//   },
// });



// WEBPACK FOOTER //
// ./src/directives/focus.js